module.exports = __webpack_public_path__ + "img/eye-white.f56babdf.svg";